module.exports = __webpack_public_path__ + "img/rosario_spring.54a6a92d.svg";